module.exports = __webpack_public_path__ + "files/316f8a8a98f168383e6ba4ff01dfeeb2.png";